import React from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, ListGroup, ListGroupItem } from 'reactstrap';
import AppList from '../../../assets/data/audience/apps.json';

const AudienceConfigModal = ({ isOpen, toggle, configData }) => {
  if (!configData) {
    return (
      <Modal isOpen={isOpen} toggle={toggle} centered>
        <ModalHeader toggle={toggle}>Audience Configuration Details</ModalHeader>
        <ModalBody>
          <div className="text-center text-danger">Veri yüklenemedi, lütfen daha sonra tekrar deneyin.</div>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={toggle}>Close</Button>
        </ModalFooter>
      </Modal>
    );
  }

  const profiles = configData.profile?.personas || configData.profiles || [];

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString();
  };

  const getAppPackageInfo = (bundleId) => {
    const app = AppList.find(app => app.bundleId === bundleId);
    return app ? app.packageInfo : bundleId;
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered>
      <ModalHeader toggle={toggle}>Audience Configuration Details</ModalHeader>
      <ModalBody>
        <ListGroup>
          <ListGroupItem><strong>User Status:</strong> {configData.userStatus || 'Bilinmiyor'}</ListGroupItem>
          {configData.osType && <ListGroupItem><strong>OS Type:</strong> {configData.osType}</ListGroupItem>}
          {configData.definition && <ListGroupItem><strong>Definition:</strong> {configData.definition}</ListGroupItem>}
          {configData.timeRange && (
            <ListGroupItem>
              <strong>Time Range:</strong> {`${formatDate(configData.timeRange.startDate)} to ${formatDate(configData.timeRange.endDate)}`}
            </ListGroupItem>
          )}
          <ListGroupItem>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <strong>Profiles:</strong>
              {configData.profile?.operationType && (
                <span style={{ fontWeight: 'bold', fontSize: '0.9em' }}>
                  Operation: {configData.profile.operationType}
                </span>
              )}
            </div>
            {profiles.length > 0 ? (
              <ul>
                {profiles.map((profile, index) => (
                  <li key={index}>{profile}</li>
                ))}
              </ul>
            ) : (
              <div>No profiles selected.</div>
            )}
          </ListGroupItem>
          {configData.generations && configData.generations.length > 0 && (
            <ListGroupItem><strong>Generations:</strong> {configData.generations.join(', ')}</ListGroupItem>
          )}
          {configData.genders && configData.genders.length > 0 && (
            <ListGroupItem><strong>Genders:</strong> {configData.genders.join(', ')}</ListGroupItem>
          )}
          {configData.app?.inApps && configData.app.inApps.length > 0 && (
            <ListGroupItem><strong>Include Apps:</strong> {configData.app.inApps.map(getAppPackageInfo).join(', ')}</ListGroupItem>
          )}
          {configData.app?.notInApps && configData.app.notInApps.length > 0 && (
            <ListGroupItem><strong>Exclude Apps:</strong> {configData.app.notInApps.map(getAppPackageInfo).join(', ')}</ListGroupItem>
          )}
          {configData.locations && configData.locations.length > 0 && (
            <ListGroupItem>
              <strong>Locations:</strong>
              <ul>
                {configData.locations.map((loc, index) => (
                  <li key={index}>{`Lat: ${loc.lat}, Lon: ${loc.lon}, Radius: ${loc.meter}m`}</li>
                ))}
              </ul>
            </ListGroupItem>
          )}
          {
          /*
          configData.licences && configData.licences.length > 0 && (
            <ListGroupItem><strong>Licences:</strong> {configData.licences.join(', ')}</ListGroupItem>
          )
          */
          }
          {configData.explain && (
            <ListGroupItem><strong>Explanation:</strong> {configData.explain}</ListGroupItem>
          )}
        </ListGroup>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={toggle}>Close</Button>
      </ModalFooter>
    </Modal>
  );
};

export default AudienceConfigModal;
